import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="navigate-back"
export default class extends Controller {
  connect() {
    this.element.addEventListener("click", this.onClick)
  }

  disconnect() {
    this.element.removeEventListener("click", this.onClick)
  }

  onClick(event) {
    history.state.turbo.restorationIndex && (event.preventDefault(), history.back())
  }
}